import { Fragment, useState } from 'react'
import { Combobox, Transition } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { XMarkIcon } from '@heroicons/react/24/outline'

export default function MultiInputSelector({items, selected, setSelected, selectorIndex, filterby}) {
  const [query, setQuery] = useState('')

  const handleRemove = (removefilterprop) => {
    setSelected((prevSelected) => prevSelected.filter(item => item[filterby] !== removefilterprop));
  };

  const filteredItems = query === ''
    ? items
    : items.filter((item) =>
        item[selectorIndex]
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(query.toLowerCase().replace(/\s+/g, ''))
      )


  return (
    <div className="w-full">
      <Combobox value={selected} onChange={setSelected} multiple>
        <div className="relative mt-1">
          <div className="relative w-full cursor-default overflow-hidden rounded-lg bg-white text-left border border-gray-300 p-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2 focus-visible:ring-offset-sky-300 sm:text-sm">
          
        {selected.length > 0 && (
        <div className='flex flex-wrap gap-1'>
            {selected?.map((item, index) => (
                <p key={index} className='bg-sky-800 text-white rounded-md px-2 py-1 flex justify-between whitespace-nowrap'><span>{item[selectorIndex]}&nbsp;</span><XMarkIcon className='h-5 w-auto' onClick={(e) => {e.stopPropagation();handleRemove(item[filterby])}}/></p>
            ))}
        </div>
        )}
            <Combobox.Input
              className="w-full border-none py-2 pl-3 pr-10 text-sm leading-5 text-gray-900 focus:ring-0"
              onChange={(event) => setQuery(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronUpDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery('')}
          >
            <Combobox.Options className="absolute z-10 mt-1 max-h-48 md:max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base ring-0 border border-gray-300 shadow-lg focus:outline-none focus:ring-0 focus-visible:ring-0 sm:text-sm">
              {filteredItems.length === 0 && query !== '' ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                filteredItems?.filter((option) => !selected.some((selected) => selected[selectorIndex] === option[selectorIndex])).map((item, index) => (
                  <Combobox.Option
                    key={index}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? 'bg-sky-700 text-white' : 'text-gray-900'
                      }`
                    }
                    value={item}
                  >
                    {({ selected }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? 'font-medium' : 'font-normal'
                          }`}
                        >
                          {item[selectorIndex]}
                        </span>
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </div>
  )
}
